// Velt configuration and utilities
import { VeltProvider } from '@veltdev/react';

// Env flags
const veltApiKey = process.env.REACT_APP_VELT_API_KEY;
const collabFlag = String(process.env.REACT_APP_COLLAB_ENABLED ?? '').toLowerCase();
const collabEnabled = collabFlag === 'true' || collabFlag === '1' || (collabFlag === '' && !!veltApiKey);

if (!collabEnabled) {
  console.info('Collaboration disabled via REACT_APP_COLLAB_ENABLED.');
}
if (!veltApiKey) {
  console.warn('REACT_APP_VELT_API_KEY is not set. Velt features will be disabled.');
}

// Export the API key for use in VeltProvider (only when enabled)
export const getVeltApiKey = () => (collabEnabled ? veltApiKey : undefined);
export const isCollabEnabled = () => collabEnabled && !!veltApiKey;

// Helpers to derive tenant and room IDs
export const getTenantPart = () => {
  let tenantPart = 'global';
  try {
    const cached = localStorage.getItem('testara_currentUser');
    if (cached) {
      const me = JSON.parse(cached);
      tenantPart = (me?.tenant?.slug || me?.tenant?.id || 'global');
    }
  } catch {}
  return String(tenantPart);
};

export const buildRoomIdForPath = (pathname = '/') => {
  const path = String(pathname || '/').replace(/\/+$/, '') || '/';
  return `testara:${getTenantPart()}${path}`;
};

export const buildEntityRoomId = (entityType, entityId) => {
  if (!entityType || !entityId) return null;
  return `testara:${getTenantPart()}:${entityType}:${entityId}`;
};

// Export VeltProvider for use in components
export { VeltProvider };

export default getVeltApiKey;
